import React from 'react';
import Reveal from './Reveal';

// variant "row": large title on the left, short description on the right (reference style).
export default function SectionHeading({ eyebrow, title, text, center = false, light = false, row = false }) {
  if (row) {
    return (
      <Reveal className="hrow">
        <h2>{title}</h2>
        {text && <p>{text}</p>}
      </Reveal>
    );
  }
  return (
    <Reveal className={`heading ${center ? 'heading--center' : ''} ${light ? 'heading--light' : ''}`}>
      {eyebrow && <span className="eyebrow">{eyebrow}</span>}
      <h2>{title}</h2>
      {text && <p>{text}</p>}
    </Reveal>
  );
}
